import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { Container, Tabs, Title } from '@mantine/core';
import { IconPalette, IconTags, IconUsers } from '@tabler/icons-react';
import { AppearancePanel } from '../../features/settings/AppearancePanel.js';
import { LabelsPanel } from '../../features/settings/LabelsPanel.js';
import { MembersPanel } from '../../features/settings/MembersPanel.js';
import { usePermissions } from '../../features/auth/useSession.js';

export const Route = createFileRoute('/_authed/settings')({
  validateSearch: z.object({
    tab: z.enum(['appearance', 'labels', 'members']).default('appearance'),
  }),
  component: SettingsPage,
});

function SettingsPage() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: '/settings' });
  const { isAdmin } = usePermissions();

  return (
    <Container size="md" py="xl" style={{ height: '100%', overflowY: 'auto' }}>
      <Title order={2} mb="lg">
        Settings
      </Title>

      <Tabs
        value={tab}
        onChange={(value) => void navigate({ search: { tab: value as typeof tab } })}
        keepMounted={false}
      >
        <Tabs.List mb="lg">
          <Tabs.Tab value="appearance" leftSection={<IconPalette size={15} />}>
            Appearance
          </Tabs.Tab>
          {isAdmin && (
            <Tabs.Tab value="labels" leftSection={<IconTags size={15} />}>
              Categories
            </Tabs.Tab>
          )}
          {isAdmin && (
            <Tabs.Tab value="members" leftSection={<IconUsers size={15} />}>
              Team
            </Tabs.Tab>
          )}
        </Tabs.List>

        <Tabs.Panel value="appearance">
          <AppearancePanel />
        </Tabs.Panel>

        {isAdmin && (
          <Tabs.Panel value="labels">
            <LabelsPanel />
          </Tabs.Panel>
        )}

        {isAdmin && (
          <Tabs.Panel value="members">
            <MembersPanel />
          </Tabs.Panel>
        )}
      </Tabs>
    </Container>
  );
}
